import { render } from "./PermissionDetail.vue?vue&type=template&id=2382b65a&scoped=true"
import script from "./PermissionDetail.vue?vue&type=script&lang=js"
export * from "./PermissionDetail.vue?vue&type=script&lang=js"

import "./PermissionDetail.vue?vue&type=style&index=0&id=2382b65a&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2382b65a"]])

export default __exports__